Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.CrossDimensionDataFormatter
  constructor: (dataTranslator, crossDimensionDataTranslator) ->
    @dataTranslator = dataTranslator
    @crossDimensionDataTranslator = crossDimensionDataTranslator

  format: (widget, cells) ->
    outer_key_indices = {}
    inner_key_indices = {}
    data = []

    current_outer_key_index = 0
    current_inner_key_index = 0

    for outer_element, inner_data of cells.data
      outer_translated = @dataTranslator.name({name: outer_element})
      if !(outer_translated of outer_key_indices)
        outer_key_indices[outer_translated] = current_outer_key_index
        current_outer_key_index += 1

      for inner_element, value of inner_data
        inner_translated = @dataTranslator.name({name: inner_element})
        if !(inner_translated of inner_key_indices)
          inner_key_indices[inner_translated] = current_inner_key_index
          current_inner_key_index += 1

        data_element = [
          outer_key_indices[outer_translated],
          inner_key_indices[inner_translated],
          value
        ]

        data.push(data_element)

    {
      outerDimensionCategories: Object.keys(outer_key_indices),
      innerDimensionCategories: Object.keys(inner_key_indices),
      data: data
    }
